import { useState } from "react";

import { UiLogoutIcon } from "@jti/brand-icons/ui-logout";
import { Button } from "@jti/core-components/components/Button";

import { useLogOut } from "../../hooks/useLogOut";

import styles from "./SignOut.module.scss";

export const SignOut = ({ label, onLogOut }: { label: string; onLogOut: () => void }) => {
  const [isPending, setIsPending] = useState(false);
  const onLogout = useLogOut(onLogOut, setIsPending);

  return (
    <Button
      onClick={onLogout}
      className={styles.signoutButton}
      variant="ghost"
      pending={isPending}
      iconAfter={UiLogoutIcon}
    >
      {label}
    </Button>
  );
};
